import { adaptEventHandler } from '../../../utils';
import { type ComponentPropsConfig } from '../../../utils/codegen';

export const componentPropsConfig: ComponentPropsConfig = {
	children: true,
	appearance: true,
	autoFocus: true,
	isDisabled: true,
	isSelected: true,
	onBlur: { value: "adaptEventHandler(onBlur)" },
	onClick: { value: "adaptEventHandler(onClick)" },
	onFocus: { value: "adaptEventHandler(onFocus)" },
	spacing: true,
	testId: true,
	shouldFitContainer: true,
	type: true,
	isLoading: true,
};

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::28924e6ddd1125fe09a4e85e52d881ce>>
 * @codegenId #loading-button
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen loading-button
 * @codegenDependency ../../../../../../../design-system/button/src/old-button/types.tsx <<SignedSource::caa42b302cf4bdc88d0bd8edd0117f1a>>
 * @codegenDependency ../../../../../../../design-system/button/src/old-button/loading-button.tsx <<SignedSource::e11a546d99697eac40708e7f1c0b047c>>
 * @codegenDependency ../../../../../../../design-system/button/src/old-button/button.tsx <<SignedSource::a537ec33d2b348563383a26a07bd7d3a>>
 * @codegenDependency ../../../../../../../design-system/button/src/old-button/shared/loading-spinner.tsx <<SignedSource::2edcd8f450ef2c1fe3a2ee4c37acfcfb>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import { LoadingButton as PlatformLoadingButton } from '@atlaskit/button';

type PlatformLoadingButtonProps = React.ComponentProps<typeof PlatformLoadingButton>;

export type LoadingButtonProps = Pick<
  PlatformLoadingButtonProps,
  'children' | 'appearance' | 'autoFocus' | 'isDisabled' | 'isSelected' | 'onBlur' | 'onClick' | 'onFocus' | 'spacing' | 'testId' | 'shouldFitContainer' | 'type' | 'isLoading'
>;

/**
 * A button triggers an event or action. They let users know what will happen next.
 */
export const LoadingButton = (props: Parameters<RenderFn>[0]) => {
  const {
    appearance,
    autoFocus,
    isDisabled,
    isSelected,
    onBlur,
    onClick,
    onFocus,
    spacing,
    testId,
    shouldFitContainer,
    type,
    isLoading,
  } = props.forgeDoc.props as LoadingButtonProps;
  return (
    <PlatformLoadingButton
      children={props.forgeDoc.children.map(c => <React.Fragment key={c.key}>{props.render(c)}</React.Fragment>)}
      appearance={appearance}
      autoFocus={autoFocus}
      isDisabled={isDisabled}
      isSelected={isSelected}
      onBlur={adaptEventHandler(onBlur)}
      onClick={adaptEventHandler(onClick)}
      onFocus={adaptEventHandler(onFocus)}
      spacing={spacing}
      testId={testId}
      shouldFitContainer={shouldFitContainer}
      type={type}
      isLoading={isLoading}
    />
  );
};
/**
 * @codegenEnd
 */
